import { FC, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { IDropdownProps } from '../model/types';
import styles from './Dropdown.module.scss';

const Dropdown: FC<IDropdownProps> = ({
  children,
  className,
  wrapperClassName,
  contentClassName,
  content,
  closeOnClick,
  positionDiff,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as Node;

    if (contentRef.current && !contentRef.current.contains(target)) {
      setOpen(false);
    }
  };

  const handleOpenDropdown: React.MouseEventHandler<HTMLDivElement> = (
    event
  ) => {
    event.stopPropagation();
    setOpen(!open);
  };

  const handleCloseOnClick: React.MouseEventHandler<HTMLDivElement> = (
    event
  ) => {
    event.stopPropagation();

    if (closeOnClick) setOpen(false);
  };

  useEffect(() => {
    if (open) {
      const element = wrapperRef.current?.getBoundingClientRect();
      document.addEventListener('mousedown', handleClickOutside);

      if (element) {
        setPosition({
          left: positionDiff?.left
            ? positionDiff?.left + element.left
            : element.left,
          top: positionDiff?.top
            ? positionDiff?.top + element.top
            : element.top,
        });
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [open]);

  return (
    <div className={`${styles.dropdownContainer} ${className}`}>
      {open &&
        createPortal(
          <div
            className={`${styles.dropdownContent} ${wrapperClassName}`}
            style={{ top: position.top, left: position.left }}
            ref={contentRef}
            onClick={handleCloseOnClick}
          >
            {content}
          </div>,
          document?.getElementById('modalRoot')!
        )}
      <div
        className={`${styles.dropdownWrapper} ${contentClassName}`}
        onClick={handleOpenDropdown}
        ref={wrapperRef}
      >
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
